import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { createMeeting, deleteMeetingMentorsMeeting, getMentorsMeetings, updateMentorsMeeting } from "../utils/api";
import toast from "react-hot-toast";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const localizer = momentLocalizer(moment);

const MentorCalendar = () => {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [slot, setSlot] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const mentorId = localStorage.getItem("mentorToken")
  const navigate = useNavigate()
  const [data, setData] = useState({
    title: "", startTime: null,
    endTime: null, date: null, mentorId: null, isPaid: false, amount: null
  })

  const handleSelectSlot = (slotInfo) => {
    console.log(slotInfo)
    setSlot(slotInfo);
    setData((prev) => ({
      ...prev,
      date: moment(slotInfo.start).format("YYYY-MM-DD"),
      startTime: moment(slotInfo.start).format("HH:mm"), // ✅ only time
      endTime: moment(slotInfo.end).format("HH:mm"),     // ✅ only time
    }));
    setShowModal(true);
  };

  const saveMeeting = async () => {
    if (!data.title) return;
    if (!mentorId) return;
    try {
      if (editingId) {
        const res = await updateMentorsMeeting(editingId, data);
        toast.success(res.message || "Meeting updated");
      } else {
        let payload = { ...data, mentorId }
        const res = await createMeeting(payload);
        toast.success(res.message || "Meeting created");
      }

    } catch (error) {
      toast.error(error.message)
      console.log(error)
    } finally {
      setShowModal(false);
      refetch()
      setData({
        ...data, title: "", startTime: null,
        endTime: null, date: null, mentorId: null, isPaid: false, amount: null
      })
      setEditingId(null)
    }


  };

  const { data: meetings, isLoading, refetch } = useQuery({
    queryKey: ['meetings'],
    queryFn: getMentorsMeetings
  })

  const toCalendarEvent = (meeting) => {
    // date comes as ISO string → extract YYYY-MM-DD
    const date = moment(meeting.date).format("YYYY-MM-DD");

    const start = moment(
      `${date} ${meeting.startTime}`,
      "YYYY-MM-DD HH:mm"
    ).toDate();

    const end = moment(
      `${date} ${meeting.endTime}`,
      "YYYY-MM-DD HH:mm"
    ).toDate();

    return {
      title: meeting.title,
      start,
      end,
      resource: meeting, // optional (useful later)
    };
  };

  const handleSelectEvent = (event) => {
    console.log(event);

    const meeting = event.resource;

    setEditingId(meeting._id);

    // ✅ use event.start / event.end
    setData({
      title: meeting.title,
      date: moment(event.start).format("YYYY-MM-DD"),
      startTime: moment(event.start).format("HH:mm"),
      endTime: moment(event.end).format("HH:mm"),
      mentorId: meeting.mentorId,
      isPaid: meeting.isPaid,
      amount: meeting.amount,
    });

    // ✅ store slot for UI display
    setSlot({
      start: event.start,
      end: event.end,
    });

    setShowModal(true);
  };


  const handleTimeChange = (type, value) => {
    setData((prev) => ({
      ...prev,
      [type === "start" ? "startTime" : "endTime"]: value,
    }));

    // Update slot so calendar preview stays correct
    setSlot((prev) => {
      if (!prev) return prev;

      const date = moment(prev.start).format("YYYY-MM-DD");

      const newStart =
        type === "start"
          ? moment(`${date} ${value}`, "YYYY-MM-DD HH:mm").toDate()
          : prev.start;

      const newEnd =
        type === "end"
          ? moment(`${date} ${value}`, "YYYY-MM-DD HH:mm").toDate()
          : prev.end;

      return {
        ...prev,
        start: newStart,
        end: newEnd,
      };
    });
  };

  const onCancelClick = () => {
    setShowModal(false)
    setEditingId(null)
    setData({
      ...data, title: "", startTime: null,
      endTime: null, date: null, mentorId: null, isPaid: false, amount: null
    })

  }

  const handleDeleteMeeting = async () => {
    try {
      await deleteMeetingMentorsMeeting(editingId)

      toast.success("Meeting deleted")

    } catch (error) {
      toast.error(error.message)
      console.log(error)
    } finally {
      setData({
        ...data, title: "", startTime: null,
        endTime: null, date: null, mentorId: null, isPaid: false, amount: null
      })
      refetch()
      setShowModal(false)
      setEditingId(null)
    }
  }

  const formatToAmPm = (time24) => {
  if (!time24) return "";

  const [hours, minutes] = time24.split(":");
  const h = parseInt(hours, 10);
  const ampm = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 || 12;

  return `${hour12}:${minutes} ${ampm}`;
};



  useEffect(() => {
    if (meetings?.data) {
      const calendarEvents = meetings.data.map(toCalendarEvent);
      setEvents(calendarEvents)
    }
  }, [meetings]);


  useEffect(() => {
    console.log(meetings)
  }, [meetings])

  return (
    <>
      {isLoading ? <CalendarSkeleton /> : <div className=" p-6 h-[78vh]
        mb-10
    rounded-2xl
    bg-white/90 backdrop-blur-xl
    shadow-[0_20px_60px_rgba(0,0,0,0.12)]
    border border-gray-200">
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          selectable
          views={["month", "week", "day"]}
          defaultView="week"
          step={30}
          timeslots={2}
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleSelectEvent}   // ✅ ADD THIS
          style={{ height: "100%" }}
        />

        {/* MODAL */}

      </div>}

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white w-full max-w-xl rounded-2xl p-6 shadow-xl">

            {/* Header */}
            <h2 className="text-xl font-semibold mb-6 text-gray-800">
              Schedule Meeting
            </h2>

            {/* Meeting Title */}
            <div className="space-y-2 mb-4">
              <label className="text-sm font-semibold text-gray-700">
                Meeting Title *
              </label>
              <input
                type="text"
                placeholder="Enter meeting title"
                value={data.title}
                onChange={(e) => setData({ ...data, title: e.target.value })}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl
                     focus:outline-none focus:ring-2 focus:ring-blue-500/20
                     focus:border-blue-500 transition-all duration-300"
              />
            </div>

            {/* Date & Time (readonly from slot) */}
            <div className="mb-4 text-sm text-gray-600 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
              {moment(slot.start).format("MMM DD, YYYY • hh:mm A")} –{" "}
              {moment(slot.end).format("hh:mm A")}
            </div>

            {/* Date (readonly) */}
            <div className="space-y-2 mb-4">
              <label className="text-sm font-semibold text-gray-700">Date</label>
              <input
                type="date"
                value={data.date}
                disabled
                className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-xl"
              />
            </div>

            {/* Start & End Time */}
            <div className="grid grid-cols-2 gap-4 mb-4">
             <div className="space-y-2">
  <label className="text-sm font-semibold text-gray-700">
    Start Time
  </label>

  <input
    type="time"
    value={data.startTime}
    onChange={(e) => handleTimeChange("start", e.target.value)}
    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl"
  />

  {/* AM/PM Preview */}
  <p className="text-xs text-gray-500 ml-2">
    {formatToAmPm(data.startTime)}
  </p>
</div>


              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700">
                  End Time
                </label>
                <input
                  type="time"
                  value={data.endTime}
                  onChange={(e) => handleTimeChange("end", e.target.value)}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl"
                />
                <p className="text-xs text-gray-500 ml-2">
    {formatToAmPm(data.endTime)}
  </p>
              </div>
            </div>


            {/* Paid / Free */}
            <div className="space-y-2 mb-4">
              <label className="text-sm font-semibold text-gray-700">
                Meeting Type *
              </label>
              <select
                value={data.isPaid ? "true" : "false"}
                onChange={(e) =>
                  setData({
                    ...data,
                    isPaid: e.target.value === "true",
                  })
                }
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl
             focus:outline-none focus:ring-2 focus:ring-blue-500/20
             focus:border-blue-500 transition-all duration-300"
              >
                <option value="false">Free</option>
                <option value="true">Paid</option>
              </select>

            </div>

            {/* Amount (only if Paid) */}
            {data.isPaid && (
              <div className="space-y-2 mb-6">
                <label className="text-sm font-semibold text-gray-700">
                  Amount (₹) *
                </label>
                <input
                  type="number"
                  placeholder="Enter amount"
                  value={data.amount}
                  onChange={(e) => setData({ ...data, amount: e.target.value })}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl
                       focus:outline-none focus:ring-2 focus:ring-blue-500/20
                       focus:border-blue-500 transition-all duration-300"
                />
              </div>
            )}

            <div className="flex items-center justify-between pt-5 border-t border-gray-200">

              {/* LEFT ACTIONS */}
              {editingId ? (
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => { navigate(`/meetingapplicants/${editingId}`) }}
                    className="
          px-4 py-2 rounded-lg text-sm font-medium
          border border-blue-600 text-blue-600
          hover:bg-blue-50 transition
        "
                  >
                    View Applicants
                  </button>

                  <button
                    onClick={handleDeleteMeeting}
                    className="
          px-3 py-2 rounded-lg text-sm
          text-red-600 hover:bg-red-50 transition
        "
                  >
                    Delete
                  </button>
                </div>
              ) : (
                <div />
              )}

              {/* RIGHT ACTIONS */}
              <div className="flex items-center gap-3">
                <button
                  onClick={() => {
                    setShowModal(false)
                    setData({
                      ...data, title: "", startTime: null,
                      endTime: null, date: null, mentorId: null, isPaid: false, amount: null
                    })
                  }}
                  className="
        px-4 py-2 rounded-lg text-sm
        bg-gray-100 text-gray-700
        hover:bg-gray-200 transition
      "
                >
                  Cancel
                </button>

                <button
                  onClick={saveMeeting}
                  className="
        px-5 py-2 rounded-lg text-sm font-semibold
        bg-blue-600 text-white
        hover:bg-blue-700 transition
      "
                >
                  Save Meeting
                </button>
              </div>
            </div>



          </div>
        </div>
      )}

    </>
  );
};

export default MentorCalendar;


const CalendarSkeleton = () => {
  return (
    <div
      className="
        p-6 h-[80vh]
        rounded-2xl
        bg-white
        border border-gray-200
        shadow-[0_20px_60px_rgba(0,0,0,0.12)]
        animate-pulse
      "
    >
      {/* Toolbar skeleton */}
      <div className="flex justify-between items-center mb-6">
        <div className="h-8 w-40 bg-gray-200 rounded-lg" />
        <div className="flex gap-2">
          <div className="h-8 w-16 bg-gray-200 rounded-lg" />
          <div className="h-8 w-16 bg-gray-200 rounded-lg" />
          <div className="h-8 w-16 bg-gray-200 rounded-lg" />
        </div>
      </div>

      {/* Calendar grid skeleton */}
      <div className="grid grid-cols-7 gap-2 h-full">
        {Array.from({ length: 7 }).map((_, col) => (
          <div key={col} className="flex flex-col gap-2">
            {/* Day header */}
            <div className="h-6 bg-gray-200 rounded-md" />

            {/* Time slots */}
            {Array.from({ length: 8 }).map((_, row) => (
              <div
                key={row}
                className="flex-1 bg-gray-100 rounded-md"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
